import { legatoImages } from '@/assets/images';
var normalHearingIcon = legatoImages.normalHearingIcon, mildHearingIcon = legatoImages.mildHearingIcon, moderateHearingIcon = legatoImages.moderateHearingIcon;
export var hearingLevelsExplained = [
    {
        title: 'Normal hearing',
        description: 'You hear everyday conversations clearly, even with a bit of noise.',
        color: 'text-green',
        icon: normalHearingIcon,
    },
    {
        title: 'Mild hearing loss',
        description: 'You hear well overall, but conversations in noisy places may take more focus.',
        color: 'text-orange',
        icon: mildHearingIcon,
    },
    {
        title: 'Moderate (or greater) hearing loss',
        description: 'Background noise can make conversations harder to understand, especially in busy settings.',
        color: 'text-red',
        icon: moderateHearingIcon,
    },
];
